import React from 'react';
import Box from '@material-ui/core/Box';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';

const propTypes = {
  showDivider: PropTypes.bool,
};

const defaultProps = {
  showDivider: true,
};

const useStyles = makeStyles(theme => ({
  root: {
    marginBottom: theme.spacing(1),
  },
  typography: {
    marginTop: theme.spacing(2),
  },
}));

function Title(props) {
  const classes = useStyles();
  const { showDivider, ...others } = props;

  return (
    <Box classes={{ root: classes.root }}>
      <Typography classes={{ root: classes.typography }} {...others} />
      {showDivider && (
        <Divider />
      )}
    </Box>
  );
}

Title.propTypes = propTypes;

Title.defaultProps = defaultProps;

export default Title;
